import axiosInstance from '../config/axios.config';

class AuthService {
    constructor() {
        this.endpoints = {
            login: '/tenant/login',
            register: '/tenant/register',
            registerV2: '/auth/register',
            forgotPassword: '/tenant/forgot-password',
            resetPassword: '/tenant/reset-password',
            changePassword: '/tenant/change-password',
            logout: '/tenant/logout',
            user: '/tenant/user'
        };
    }

    async login(email, password, rememberMe = false) {
        try {
            const response = await axiosInstance.post(this.endpoints.login, {
                email,
                password,
                remember: rememberMe
            });

            if (response.data.token) {
                this.setAuthData(response.data);
            }

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async register(userData) {
        try {
            const response = await axiosInstance.post(this.endpoints.register, userData);

            if (response.data.token) {
                this.setAuthData(response.data);
            }

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async registerV2(userData) {
        try {
            const response = await axiosInstance.post(this.endpoints.registerV2, userData);

            if (response.data.token) {
                this.setAuthData(response.data);
            }

            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async forgotPassword(email) {
        try {
            const response = await axiosInstance.post(this.endpoints.forgotPassword, { email });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async resetPassword(token, password, passwordConfirmation) {
        try {
            const response = await axiosInstance.post(this.endpoints.resetPassword, {
                token,
                password,
                password_confirmation: passwordConfirmation
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async changePassword(passwordData) {
        try {
            console.log('Calling change password API:', this.endpoints.changePassword);
            console.log('Base URL:', axiosInstance.defaults.baseURL);
            const response = await axiosInstance.post(this.endpoints.changePassword, passwordData);
            return response.data;
        } catch (error) {
            console.error('Change password error:', error.response || error);
            throw this.handleError(error);
        }
    }

    async logout() {
        try {
            await axiosInstance.post(this.endpoints.logout);
        } catch (error) {
            // Even if logout fails on server, clear local data
            console.error('Logout error:', error);
        } finally {
            this.clearAuthData();
        }
    }

    async getCurrentUser() {
        try {
            const response = await axiosInstance.get(this.endpoints.user);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    setAuthData(data) {
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('isAuthenticated', 'true');
        
        // Store user roles for menu filtering
        if (data.roles) {
            localStorage.setItem('userRoles', JSON.stringify(data.roles));
        }
        
        // If the API returns tenant-specific data, store it
        if (data.tenant) {
            localStorage.setItem('tenantData', JSON.stringify(data.tenant));
        }
    }

    clearAuthData() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('userRoles');
        localStorage.removeItem('tenantData');
    }

    isAuthenticated() {
        return !!localStorage.getItem('authToken');
    }

    getUser() {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    }

    getToken() {
        return localStorage.getItem('authToken');
    }

    handleError(error) {
        if (error.response) {
            // Server responded with error
            const message = error.response.data.message || 
                           error.response.data.error || 
                           'An error occurred';
            
            return {
                message,
                errors: error.response.data.errors || {},
                status: error.response.status
            };
        } else if (error.request) {
            // Request made but no response
            return {
                message: 'Unable to connect to server. Please check your connection.',
                errors: {},
                status: 0
            };
        } else {
            // Something else happened
            return {
                message: error.message || 'An unexpected error occurred',
                errors: {},
                status: 0
            };
        }
    }
}

export default new AuthService();